import i18next from 'i18next';
import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import toasts from '../../commonUtils/toasts';
import { useState, useEffect } from 'react';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import FillPartnerDetails from './FillPartnerDetails';
import ManageSites from './ManageSites';
import './PartnerModal.scss';
import { v4 as uuid4 } from 'uuid';
import { IActivateSubscriptionPayload, IUserActivationResponse } from '../onboardingModels';
import authService from '../../../authService';
import { Modal, Icon, Button, Tab, Loader } from '@scuf/common';
import useFetch, { IUseFetch } from '../../commonUtils/useFetch';
import { EMPTY_GUID, IAssociatedResources, IGroupedOrgSiteList, ISearchSiteList, ISubscriptionList } from './SKULIst/SKUModels';
import { groupBy } from 'lodash';
import { useSelector } from 'react-redux';
import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import moment from 'moment';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getFeatureFlagValuebasedOnSIOrg } from '../../commonUtils/LDFlagUtils';
interface IPartnerModalProps extends IAPIPackage {
  onClose: Function;
  onSave: Function;
  siteId: string;
  panelSelectedRow: ISubscriptionList;
  isLoading: boolean;
}

export const PartnerModal = (props: IPartnerModalProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [selectedSites, setSelectedSites] = useState<IGroupedOrgSiteList>({});
  const [isSitesUpdated, setIsSitesUpdated] = useState<boolean>(false);
  const [
    isLoadingPostSaveSubscription,
    setIsLoadingPostSaveSubscription
  ] = useState<boolean>(false);
  const [warningUpcomingIndex, setWarningUpcomingIndex] = useState<number>(0);
  const [showWarningModal, setShowWarningModal] = useState<Boolean>(false);
  const [siteId, setSiteId] = useState<string>('');
  const [associatedResourcesCount, setAssociatedResourcesCount] = useState<number>(0);
  const [associatedResources, setAssociatedResources] = useState<IAssociatedResources>();
  const [activationSubscriptionLoading, setActivationSubscriptionLoading] = useState<boolean>(false);
  const [siteName, setSiteName] = useState<string>('');
  const orgSelected = useSelector((state: IOrganisationState) => state.globalShared.selectedOrganisation);
  const organisations = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationList
  );
  const featureFlags = useFlags();
  const enableBacsFlow = getFeatureFlagValuebasedOnSIOrg('enableBacsFlow', featureFlags, orgSelected, organisations);

  const getHeader = () => {
    return `${i18next.t('editSKU')}`;
  };

  const handleChange = (value: any, type: string) => {
    if (type === 'associatedSites') {
      let groupedOrgSitesList = groupBy(value, function (val) { return val.orgId; });
      setSelectedSites(groupedOrgSitesList);
    } else if (type === 'ActivateSubscription') {
      activateNewSubscription(siteId, props.panelSelectedRow.subscriptionId);
    }
  };

  const [
    getAssociatedResourceResponse,
    isLoadingAssociatedResource,
    errorAssociatedResource,
    getAssociatedResources
  ]: IUseFetch<IAssociatedResources> = useFetch(
    `${props.baseURL}/api/v1/subscriptions/${props.panelSelectedRow.subscriptionId}?allDetails=true`,
    authService.authFetch,
    undefined,
    true
  );


  useEffect(() => {
    if (props.panelSelectedRow.subscriptionId !== '' && props.panelSelectedRow.subscriptionId !== EMPTY_GUID) {
      getAssociatedResources();
    }
  }, [props.panelSelectedRow.subscriptionId]);


  useEffect(() => {
    if (getAssociatedResourceResponse) {
      let resourcesCount = 0;
      let associatedResources: any = [];
      getAssociatedResourceResponse.resourceGroup.resourceMappings.map((resource: any) => {
        resourcesCount = + resource.cardinality;
        for (let i = 0; i < resource.cardinality; i++) {
          associatedResources.push(resource.resource);
        }
      });
      setAssociatedResources(associatedResources);
      if (resourcesCount > 0) {
        setAssociatedResourcesCount(resourcesCount);
        setSiteId(getAssociatedResourceResponse.resourceGroup.resourceMappings[0].resource.id);
        setSiteName(getAssociatedResourceResponse.resourceGroup.resourceMappings[0].resource.name);
      }
    }
  }, [getAssociatedResourceResponse]);

  const associateSites = () => {
    // call associate subscription API
    let errorCount = 0;
    setIsLoadingPostSaveSubscription(true);
    setIsSitesUpdated(false);
    let requestObj: string[] = [];
    const subscriptionObj: any[] = [];
    if (selectedSites && Object.keys(selectedSites).length > 0) {

      Object.values(selectedSites).map((sites: any, index: number) => {
        requestObj.push(
          `${props.baseURL}/api/v4/subscriptions/orgs/${sites[0].orgId}`
        );

        subscriptionObj.push({
          SubscriptionNumber: props.panelSelectedRow.subscriptionNumber,
          OrderNumber: props.panelSelectedRow.orderNumber,
          BundleId: props.panelSelectedRow.bundleDetail,
          ResourceMapping: null,
          Resources: [] as any
        });
        sites.forEach((site: any) => {
          const resourceExistIndex = subscriptionObj[index].Resources.findIndex((resource: any) => resource.resourceId === site.siteId);
          if (resourceExistIndex === -1) {
            subscriptionObj[index].Resources.push({ resourceId: site.id, cardinality: 1 });
          } else {
            subscriptionObj[index].Resources[resourceExistIndex].cardinality = subscriptionObj[index].Resources[resourceExistIndex].cardinality + 1;
          }
        });
      });

      Promise.all(
        requestObj.map((url, index) =>
          props
            .authFetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(subscriptionObj[index])
            })
            .catch(error => console.log(error))
        )
      )
        .then(data => {
          // assign to requested URL as define in array with array index.
          errorCount = data.filter(response => response ? response.status !== 200 : false).length;
          setIsLoadingPostSaveSubscription(false);
          if (errorCount > 0) {
            toasts.error(i18next.t('siteFailedMsg'));
            props.onSave();
            setSelectedSites({});
          } else {
            toasts.success(i18next.t('siteSuccessMsg'));
            props.onSave();
            setSelectedSites({});
          }
          props.onClose();
          getAssociatedResources();
        })
        .catch(error => {
          setIsLoadingPostSaveSubscription(false);
          toasts.error(i18next.t('problemWithRequest', { siteCount: errorCount, totalSite: selectedSites.length }));
        });
    }
  };

  const activateSubscription = (siteId: string, subscriptionId: string) => {
    setActivationSubscriptionLoading(true);
    const commandId = uuid4();

    props
      .authFetch(
        `${props.baseURL}/api/v1/subscriptions/${subscriptionId}/activate-subscription-commands/${commandId}`,
        {
          method: 'PUT'
        }
      )
      .then(res => res.json() as Promise<IUserActivationResponse>)
      .then((response: any) => {
        if (
          response &&
          response.output &&
          response.output.status !== 'Failed'
        ) {
          toasts.success(
            i18next.t('subscriptionActivateSuccess', {
              siteName: "all the sites"
            })
          );
          props.onSave();
        } else {
          toasts.error(i18next.t('subscriptionActivateError'));
        }
      })
      .catch(() => {
        toasts.error(i18next.t('subscriptionActivateError'));
      })
      .finally(() => {
        setActivationSubscriptionLoading(false);
        getAssociatedResources();
      });
  };

  const activateNewSubscription = (siteId: string, subscriptionId: string) => {
    setActivationSubscriptionLoading(true);
    const commandId = uuid4();

    const currentDate = new Date()
    const currentMonth = currentDate.getUTCMonth() + 1 > 9 ? currentDate.getUTCMonth() + 1 : `0${currentDate.getUTCMonth() + 1}`;
    const parseDate = new Date();
    const convertedDate = `${parseDate.getFullYear()}-${parseDate.getUTCMonth() + 1 > 9 ? parseDate.getUTCMonth() + 1 : `0${parseDate.getUTCMonth() + 1}`}-${parseDate.getDate()}`
    const formatActivationDate = `${currentDate.getFullYear()}-${currentMonth}-${currentDate.getDate()}`

    const activateRequestBody: IActivateSubscriptionPayload = {
      action: 'Activation',
      subscriptionNumber: props.panelSelectedRow.subscriptionNumber,
      activationDate: moment(formatActivationDate).format('YYYY-MM-DD').toString(),
      organizationName: orgSelected.name,
      siteName: siteName,
      countryName: null,
      anniversaryDate: moment(convertedDate).format('YYYY-MM-DD').toString(),
      sector: null,
      isAnniversaryDateSkipped: false,
      billingCycle: null,
    }
    let activateSubscriptionV1Url = `${props.baseURL}/api/v1/subscriptions/${subscriptionId}/activate-subscription-commands-V1/${commandId}`;
    if (enableBacsFlow) { // new activation API for BACS flow
      activateSubscriptionV1Url = `${props.baseURL}/api/v1/subscriptions/resources/${siteId}/subscriptions/${subscriptionId}/activate-subscription-commands-V1/${commandId}`;
    }
      props
      .authFetch(
        activateSubscriptionV1Url,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(activateRequestBody),
        }
      )
      .then(res => res.json() as Promise<IUserActivationResponse>)
      .then((response: any) => {
        if (
          response &&
          response.output &&
          response.output.status !== 'Failed'
        ) {
          toasts.success(
            i18next.t('subscriptionActivateSuccess', {
              siteName: "all the sites"
            })
          );
          props.onSave();
        } else {
          toasts.error(i18next.t('subscriptionActivateError'));
        }
      })
      .catch(() => {
        toasts.error(i18next.t('subscriptionActivateError'));
      })
      .finally(() => {
        setActivationSubscriptionLoading(false);
        getAssociatedResources();
      });
  };

  const onTabChange = (value: number) => {
    if (activeIndex !== value && isSitesUpdated) {
      setShowWarningModal(true);
      setWarningUpcomingIndex(value);
      setActiveIndex(activeIndex);
    } else {
      setActiveIndex(value);
    }
  }

  const showWarning = () => {
    return (
      <Modal
        size="small"
        onClose={() => setShowWarningModal(false)}
        open={true}
        closeOnDocumentClick={false}
        className="warning-modal"
      >
        <Modal.Content>
          <Icon
            name="badge-warning"
            className={`status-icon`}
            root="common"
            size="medium"
          />
          <div className="desc">
            <b>{i18next.t('warningHeader')}</b><br />
            {i18next.t('warningMessage')}
          </div>
        </Modal.Content>
        <Modal.Footer>
          <Button type="link" size="medium" className="close-button" content={i18next.t('cancel')} onClick={() => setShowWarningModal(false)} />
          <Button type="link" size="medium" className="save-button" content={i18next.t('deleteSure')} onClick={() => { setShowWarningModal(false); setActiveIndex(warningUpcomingIndex); setIsSitesUpdated(false); }} />
        </Modal.Footer>
      </Modal>
    );
  }
  return (
    <div className="main-partner-modal">
      {showWarningModal && showWarning()}
      <SplitPanelUtil.Panel onOverlayClicked={() => props.onClose(false)}>
        <SplitPanelUtil.PanelHeader onPanelClose={() => props.onClose(false)}>
          <SplitPanelUtil.PanelHeaderTitle>
            {getHeader()}
          </SplitPanelUtil.PanelHeaderTitle>
        </SplitPanelUtil.PanelHeader>
        <SplitPanelUtil.PanelContent>
          {(isLoadingAssociatedResource || (props.isLoading && (props.panelSelectedRow.subscriptionId === '' || props.panelSelectedRow.subscriptionId === EMPTY_GUID))) ? <Loader text={i18next.t('loading')} overlayOpacity={0.5} /> : <Tab
            activeIndex={activeIndex}
            onTabChange={(activeIndexNum: number) => onTabChange(activeIndexNum)}
          >
            <Tab.Pane title={i18next.t('skuDetails')}>
              <SplitPanelUtil.PanelContentMain className="partner-modal-content">
                <SplitPanelUtil.PanelContentMainSection>
                  <FillPartnerDetails panelSelectedRow={props.panelSelectedRow} activatingSubscription={activationSubscriptionLoading}
                    handleChange={handleChange} associatedResourcesCount={associatedResourcesCount} associatedResources={associatedResources} activatedOn={getAssociatedResourceResponse ? getAssociatedResourceResponse.activatedOn : ''} />
                </SplitPanelUtil.PanelContentMainSection>
              </SplitPanelUtil.PanelContentMain>
            </Tab.Pane>
            <Tab.Pane title={i18next.t('manageSites')}>
              <SplitPanelUtil.PanelContentMain className="partner-modal-content">
                <SplitPanelUtil.PanelContentMainSection>
                  <ManageSites
                    {...props.panelSelectedRow}
                    associatedResources={(associatedResources !== undefined && associatedResources) ? associatedResources : []}
                    handleChange={handleChange}
                    onAddClick={(data: boolean) => setIsSitesUpdated(data)}
                  />
                </SplitPanelUtil.PanelContentMainSection>
              </SplitPanelUtil.PanelContentMain>
            </Tab.Pane>
          </Tab>
          }
        </SplitPanelUtil.PanelContent>
        {(activeIndex === 1) && (
          <SplitPanelUtil.PanelFooter>
            <Button
              type="secondary"
              size="medium"
              content={i18next.t('cancel')}
              onClick={() => props.onClose(false)}
            />
            <Button
              type="primary"
              size="medium"
              content={i18next.t('submit')}
              loading={isLoadingPostSaveSubscription}
              disabled={Object.keys(selectedSites).length === 0}
              onClick={() => associateSites()}
            />
          </SplitPanelUtil.PanelFooter>
        )}
      </SplitPanelUtil.Panel>
    </div>
  );
};

export default consumeAPIs(PartnerModal);